import clsx from 'clsx';
import Image from 'next/image';
import { useState } from 'react';
import { twMerge } from '@/lib/twMerge';
import Warning from '@/components/Icons/Warning';
import { useYoutubeChannelData } from '@/components/UBSafelist/hooks/useYoutubeChannelData';
import { useHasRole } from '@/hooks/auth';
import type { YouTubeChannel } from '@/components/UBSafelist/types';
const iconClassName = 'absolute bottom-0 -right-1 size-1/2';
const YouTubeChannelImage = ({
  channel,
  className
}: {
  channel: YouTubeChannel;
  className?: string;
}) => {
  const {
    data: channelData
  } = useYoutubeChannelData(channel.channelId);
  const [isLoading, setIsLoading] = useState(true);
  const isFree = useHasRole('Free');
  return <div className={twMerge('relative aspect-square h-full max-h-10 w-auto', className)} data-sentry-component="YouTubeChannelImage" data-sentry-source-file="index.tsx">
      <div className={clsx('z-0 aspect-square h-full w-full rounded-full bg-gray-300 transition-opacity dark:bg-gray-700', isLoading ? 'animate-pulse' : 'opacity-0')} />
      {channelData && <Image alt={channel.channelName} className={twMerge('pointer-events-none absolute top-0 left-0 aspect-square h-auto w-full rounded-full object-cover object-center transition-opacity duration-700', isFree && 'opacity-60')} fill key={channel.channelId} onLoad={() => {
      setIsLoading(false);
    }} src={channelData?.thumbnails?.default?.url} unoptimized />}
      {isFree && <Warning className={iconClassName} />}
    </div>;
};
export default YouTubeChannelImage;